export function resolveNotificationNavigationTarget(path, currentOrigin) {
  if (typeof path !== 'string' || path.length === 0 || typeof currentOrigin !== 'string') return null;

  try {
    const target = new URL(path, currentOrigin);
    if (target.origin !== currentOrigin) return null;
    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return null;
  }
}
